import React from "react";


import withStyles from "@material-ui/core/styles/withStyles";



import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import Carousel from "react-slick";
import Card from "components/Card/Card.jsx";
import carouselStyle from "assets/jss/material-kit-react/views/componentsSections/carouselStyle.jsx";

import hex from"assets/img/aa.jpg"; 
import SectionCarousel from "./SectionCarousel.jsx";
import SectionMisVis from "./SectionMisVis.jsx";


class SectionLogo extends React.Component {
  render() {
    const { classes } = this.props;
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,

    };
    return (
      <div>  
        <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={8} className={classes.marginAuto}>
              <Card carousel>
                <Carousel {...settings}>
                   <div>
                   <h5 className={classes.focu}>
                   Focus Engineering Sectors
                   </h5>
                    <img
                      src={hex}
                      alt="factors"
                      className="slick-image"
                    />
                    </div>
                    </Carousel>
                    </Card>
                    </GridItem>
                    </GridContainer>
                  <br />
                    <SectionCarousel />

                  <SectionMisVis/>
          
      </div>

         </div> 

    );
  }
}

export default withStyles(carouselStyle)(SectionLogo);



// WEBPACK FOOTER //
// ./src/views/Components/Sections/SectionLogo.jsx